import { useMutation } from '@tanstack/react-query';

import { updateInvoiceStatusApi } from '../api';

export default function useUpdateInvoiceStatusMutation(options?: any) {
  return useMutation(updateInvoiceStatusApi, options);
}
